import React from "react";

export const DSTaiSanConst = {
  TinhTrangTaiSan: {
    DaThanhLy: 6,
    DangCamDo: 10,
    CanThanhLy: 7,
    DangChoThue: 3,
    SoHuu: 4,
    CamNhanVay: 5,
    DaTra: 2,
    CanThuHoi: 8,
    CanChuocDo: 9,
    NhapHang: 11,
    BanHang: 12,
  },
};
export const DanhSachBankConst = {
  Bank: [
    { value: "MBBank", label: "MBBank" },
    { value: "VPBank", label: "VPBank" },
    { value: "Vietcombank", label: "Vietcombank" },
    { value: "VietinBank", label: "VietinBank" },

  ],
}
export const DanhSachTaiSanCombo = {
  KhoDefault: "- Kho -",
  KhoCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Kho 1" },
    { value: "2", label: "Kho 2" },
  ],
  TrangThaiTaiSanDefault: { value: "-1", label: "Trạng thái" },
  TrangThaiTaiSanCombo: [
    { value: "-1", label: "Trạng thái" },
    { value: "6", label: "Đã thanh lý" },
    { value: "10", label: "Đang cầm đồ" },
    { value: "7", label: "Cần thanh lý" },
    { value: "3", label: "Đang cho thuê" },
    { value: "4", label: "Sở hữu" },
    { value: "5", label: "Cầm nhận vay" },
    { value: "2", label: "Đã trả" },
    { value: "8", label: "Cần thu hồi" },
    { value: "9", label: "Cần chuộc đồ" },
    { value: "11", label: "Nhập hàng" },
    { value: "12", label: "Bán hàng" },
  ],
  TinhTrangDefault1: { value: "1", label: "Bình thường" },
  TinhTrangCombo1: [
    { value: "1", label: "Bình thường" },
    { value: "3", label: "Cảnh báo" },
  ],
  TinhTrangDefault: { value: "0", label: "Tất cả" },
  TinhTrangCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Bình thường" },
    { value: "3", label: "Cảnh báo" },
  ],
  LoaiTaiSanDefault: "- Loại tài sản -",
  LoaiTaiSanCombo: [
    { value: "0", label: "Tất cả" },
    { value: "XM", label: "Xe Máy" },
    { value: "OTO", label: "Ô Tô" },
  ],
  LoaiGoiVayCombo: [
    { value: "TheChap", label: "Thế chấp" },
    { value: "TinChap", label: "Tín chấp" },
  ],
};
